<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
// import Stat from '@components/widget-stat'
import { latLng, icon } from 'leaflet'
import dayjs from 'dayjs'
import Certificate from '@views/pages/dashboard/include/Certificate'
import { fleetsActions } from '@state/helpers';
import AddFleet from './include/AddFleet.vue'
/**
 * Starter component
 */
export default {
  page: {
    title: 'Dashboard',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, Certificate, AddFleet },
  data() {
    return {
      title: 'Starter',
      items: [
        {
          text: 'Home',
          active: true,
        },
      ],
      dateConfig: {
        mode: 'range',
      },
      modal: {
        show: false,
        variants: [
          'primary',
          'secondary',
          'success',
          'warning',
          'danger',
          'info',
          'light',
          'dark',
        ],
        headerBgVariant: 'secondary',
        headerTextVariant: 'light',
        bodyBgVariant: 'light',
        bodyTextVariant: 'dark',
        footerBgVariant: 'info',
        footerTextVariant: 'dark',
      },
      selectedCompanyName: null,
      selectedContract: null,
      selectedFleetCategory: 'awb',
      fleetCategory: [
        {
          label: 'Anchor Handling Tug Supply',
          color: 'success',
          value: 'ahts',
        },
        {
          label: 'Diving Support Vessel',
          color: 'warning',
          value: 'dsv',
        },
        {
          label: 'Accommodation Workboats',
          color: 'primary',
          value: 'awb',
        },
      ],
      technicalActive: {
        technical_module: 'active',
      },
      technical: [
        {
          name: 'technical_module',
          label: 'Yes',
          value: 'active',
          disabled: false,
        },
        {
          name: 'technical_module',
          label: 'No',
          value: 'inactive',
          disabled: false,
        },
      ],
      CompanyName: [
        { value: '1', text: 'Transcoal Pacific' },
        { value: '2', text: 'Sentra Makmur Lines' },
        { value: '3', text: 'Energi Transporter Indonesia' },
      ],
      Contract: [
        { value: '1', text: 'Owned by Company' },
        { value: '2', text: 'Chartered' },
      ],
      selectedDate: [new Date().setDate(new Date().getDate() - 7), new Date()],
      statData: [
        {
          title: 'Total Certificate',
          value: '2.100',
          icon: 'book',
          color: 'primary',
        },
        {
          title: 'Expired',
          value: 82,
          icon: 'info',
          color: 'danger',
        },
        {
          title: '1 Bulan Akan Expired',
          value: 11,
          icon: 'list',
          color: 'warning',
        },
        {
          title: 'Progress',
          value: 15,
          icon: 'clock',
          color: 'info',
        },
      ],
      /* center: { lat: 45.508, lng: -73.587 }, */
      // Google Maps
      mapLoaded: false,
      centerGMaps: { lat: 10.0, lng: 10.0 },
      markersGMaps: [
        {
          label: 'AWB OCB Tanjung Lesung',
          code: 'awb-ocb-tanjung-lesung',
          position: { lat: -2.548926, lng: 118.0148634 },
          icon: {
            url: 'fleet/awb.png',
            size: { width: 60, height: 90, f: 'px', b: 'px' },
            scaledSize: { width: 62, height: 67, f: 'px', b: 'px' },
            offset: { x: -10, y: 17.5 },
            labelOrigin: { x: 30, y: 75 },
          },
          description: 'Description 1',
        },
        {
          label: 'AWB Star Onyx',
          code: 'awb-star-onyx',
          position: { lat: -5.217402, lng: 129.618053 },
          icon: {
            url: 'fleet/awb.png',
            size: { width: 60, height: 90, f: 'px', b: 'px' },
            scaledSize: { width: 62, height: 67, f: 'px', b: 'px' },
            offset: { x: -10, y: 17.5 },
            labelOrigin: { x: 30, y: 75 },
          },
          description: 'Description 2',
        },
        {
          label: 'DSV Atlas Hawk',
          code: 'dsv-atlas-hawk',
          position: { lat: -4.506502, lng: 109.282306 },
          icon: {
            url: 'fleet/dsv.png',
            size: { width: 60, height: 90, f: 'px', b: 'px' },
            scaledSize: { width: 62, height: 67, f: 'px', b: 'px' },
            offset: { x: -10, y: 17.5 },
            labelOrigin: { x: 30, y: 75 },
          },
          description: 'Description 3',
        },
      ],
      infoMarker: null,
      infoWindow: { lat: 10, lng: 10.0 },
      window_open: false,
      optionsGMaps: {
        zoomControl: true,
        mapTypeControl: true,
        streetViewControl: true,
        zoomControlOptions: {
          position: 3,
        },
        streetViewControlOptions: {
          position: 3,
        },
        mapTypeControlOptions: {
          position: 3,
        },
      },
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        content: '',
        //optional: offset infowindow so it visually sits nicely on top of our marker
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      selectedLocation: null,
      infoBoxOpen: false,
      // Open Street Map
      zoom: 5,
      center: latLng(-2.548926, 118.0148634),
      url: 'https://api.maptiler.com/maps/hybrid/{z}/{x}/{y}.jpg?key=T7IfHizkxdz98X76UCBi',
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      withPopup: latLng(-2.548926, 118.0148634),
      withTooltip: latLng(-5.217402, 129.618053),
      dsvAtlasHawk: latLng(-4.506502, 109.282306),
      ahtsTritonArjuna: latLng(-0.385786, 107.194904),
      ahtsTritonJawara: latLng(-0.319864, 125.950798),
      ahtsAtlasHarpectra: latLng(-6.742234, 136.231812),
      currentZoom: 11.5,
      currentCenter: latLng(-2.548926, 118.0148634),
      showParagraph: true,
      mapOptions: {
        zoomSnap: 0.5,
      },
      showMap: true,
      icon: icon({
        iconUrl: 'fleet/awb.png',
        iconSize: [62, 67],
        iconAnchor: [16, 37],
      }),
      iconDSV: icon({
        iconUrl: 'fleet/dsv.png',
        iconSize: [62, 67],
        iconAnchor: [16, 37],
      }),
      iconAHTS: icon({
        iconUrl: 'fleet/ahts.png',
        iconSize: [62, 67],
        iconAnchor: [16, 37],
      }),
      dynamicStyle: {
        'task-list-header-label': {
          'font-weight': 'bold',
        },
      },
      tasks: [
        {
          id: 1,
          label: 'Make some noise',
          user: '<a href="https://www.google.com/search?q=John+Doe" target="_blank" style="color:#0077c0;">John Doe</a>',
          start: this.getDate(-24 * 5),
          duration: 15 * 24 * 60 * 60 * 1000,
          progress: 85,
          type: 'project',
          // collapsed: true,
        },
        {
          id: 2,
          label: 'With great power comes great responsibility',
          user: '<a href="https://www.google.com/search?q=Peter+Parker" target="_blank" style="color:#0077c0;">Peter Parker</a>',
          parentId: 1,
          start: this.getDate(-24 * 4),
          duration: 4 * 24 * 60 * 60 * 1000,
          progress: 50,
          type: 'milestone',
          collapsed: true,
          style: {
            base: {
              fill: '#1EBC61',
              stroke: '#0EAC51',
            },
            /* 'tree-row-bar': {
              fill: '#1EBC61',
              stroke: '#0EAC51'
            },
            'tree-row-bar-polygon': {
              stroke: '#0EAC51'
            } */
          },
        },
        {
          id: 3,
          label: 'Courage is being scared to death, but saddling up anyway.',
          user: '<a href="https://www.google.com/search?q=John+Wayne" target="_blank" style="color:#0077c0;">John Wayne</a>',
          parentId: 2,
          start: this.getDate(-24 * 3),
          duration: 2 * 24 * 60 * 60 * 1000,
          progress: 100,
          type: 'task',
        },
        {
          id: 4,
          label: 'Put that toy AWAY!',
          user: '<a href="https://www.google.com/search?q=Clark+Kent" target="_blank" style="color:#0077c0;">Clark Kent</a>',
          start: this.getDate(-24 * 2),
          duration: 2 * 24 * 60 * 60 * 1000,
          progress: 50,
          type: 'task',
          dependentOn: [3],
        },
      ],
      options: {
        maxRows: 100,
        maxHeight: 300,
        title: {
          label: 'Your project title as html (link or whatever...)',
          html: false,
        },
        row: {
          height: 24,
        },
      },
      iconSize: [62, 67],
      iconAnchor: [16, 37],
      params: {
        page: 1,
        active: true,
      },
      fleetActivities: [],
    }
  },
  computed: {
    userVehicles () {
      return this.$store.state.auth.profile.vehicle || []
    },
    vehicleTypes() {
      let vehicleTypes = []
      this.userVehicles.forEach(vehicle => {
        const vehicleTypeExist = vehicleTypes.find(v => v.id === vehicle.vehicleType.id)
        if (!vehicleTypeExist) {
          vehicle.vehicleType.checked = true
          vehicleTypes.push(vehicle.vehicleType)
        }
      });
      return vehicleTypes;
    }
  },
  async mounted() {
    await this.fetchFleetActivities()

    //set bounds of the map
    this.$refs.gmap.$mapPromise.then((map) => {
      const bounds = new google.maps.LatLngBounds()
      for (let m of this.markers) {
        bounds.extend(m.position)
      }
      map.fitBounds(bounds)
    })
  },
  methods: {
    ...fleetsActions,
    zoomUpdate(zoom) {
      this.currentZoom = zoom
    },
    centerUpdate(center) {
      this.currentCenter = center
    },
    getDate(hours) {
      const currentDate = new Date()
      const currentYear = currentDate.getFullYear()
      const currentMonth = currentDate.getMonth() + 1
      const currentDay = currentDate.getDate()
      const timeStamp = new Date(
        `${currentYear}-${currentMonth}-${currentDay} 00:00:00`
      ).getTime()
      return new Date(timeStamp + hours * 60 * 60 * 1000).getTime()
    },
    getInfoWindowContent: function (marker) {
      return `<div style="width: 300px;">
              <router-link to=""><h4>${marker.label}</h4></router-link>
              <b-row>
                 <b-col md="12">
                   <b-card-text>
                     <b-row class="text-center">
                        <b-col v-b-modal.operational-${marker.code} cols="4" md="3" class="mb-3">
                           <img v-b-tooltip.top="'Operational'" src="../../../../assets/images/flaticon/operational.png" alt="Responsive Image" style="cursor: pointer;">
                           <small class="text-muted">Operational</small>
                        </b-col>
                        <b-modal id="operational-${marker.code}" size="huge" :no-close-on-backdrop="true"
                                :header-bg-variant="modal.headerBgVariant"
                                :header-text-variant="modal.headerTextVariant"
                                :body-bg-variant="modal.bodyBgVariant"
                                :body-text-variant="modal.bodyTextVariant"
                                hide-footer>
                           <template v-slot:modal-header="{ close }">
                             <h5 class="text-white">${marker.name} - Operational</h5>

                             <b-button size="md" variant="outline-danger" @click="close">
                               <i class="fa fa-times"></i> Close
                             </b-button>
                           </template>
                           <p>Test</p>
                        </b-modal>
                        <b-col v-b-modal.certificate-${marker.code} cols="4" md="3" class="mb-3">
                         <img v-b-tooltip.top="'Certificate'" src="../../../../assets/images/flaticon/certificate.png" alt="Responsive image" style="cursor: pointer;">
                         <small class="text-muted">Certificate</small>
                        </b-col>
                        <b-modal id="certificate-${marker.code}" size="huge" :no-close-on-backdrop="true"
                                :header-bg-variant="modal.headerBgVariant"
                                :header-text-variant="modal.headerTextVariant"
                                :body-bg-variant="modal.bodyBgVariant"
                                :body-text-variant="modal.bodyTextVariant"
                                hide-footer>
                         <template v-slot:modal-header="{ close }">
                           <h5 class="text-white">AWB OCB Tanjung Lesung - Certificate</h5>
                           <b-button size="md" variant="outline-danger" @click="close">
                             <i class="fa fa-times"></i> Close
                           </b-button>
                         </template>
                         <Certificate></Certificate>
                       </b-modal>
                     </b-row>
                   </b-card-text>
                 </b-col>
               </b-row></div>`
    },
    async fetchFleetActivities() {
      let params = { ...this.params }

      params = this.$options.filters.cleanObject(params)
      let res = await this.getFleetActivities(params)

      this.fleetActivities = []

      res.data.forEach(vehicle => {
        const vehicleExist = this.userVehicles.find(v => v.id === vehicle.id)
        if (vehicleExist) this.fleetActivities.push(vehicle)
      });
    },
    getLatLng(lat, lng) {
      return latLng(lat, lng)
    },
    getIcon(icon) {
      if (!icon || !icon.url) {
        return 'fleet/awb.png'
      }

      return this.$options.filters.checkPhoto(icon.url, 'fleet/awb.png')
    }
  },
}
</script>

<template>
  <Layout>
    <a id="add-vehicle" v-b-modal.add-fleet href="#" class="button-float">
      <i class="fa fa-plus my-button-float"></i>
      <i class="fa fa-plus fa fa-ship my-button-float"></i>
    </a>
    <b-modal
      id="add-fleet"
      size="xl"
      :no-close-on-backdrop="true"
      :header-bg-variant="modal.headerBgVariant"
      :header-text-variant="modal.headerTextVariant"
      :body-bg-variant="modal.bodyBgVariant"
      :body-text-variant="modal.bodyTextVariant"
      hide-footer
    >
      <template v-slot:modal-header="{ close }">
        <h5 class="text-white">Add More Your Fleet</h5>
        <!-- Emulate built in modal header close button action -->
        <b-button size="md" variant="outline-danger" @click="close">
          <i class="fa fa-times"></i> Close
        </b-button>
      </template>
        <AddFleet />
    </b-modal>

    <b-tooltip target="add-vehicle">Add More Your Fleet</b-tooltip>
    <!-- Open Street View -->
    <div style="height: 92%; width: 100%; position: fixed; margin-left: -20px">
      <l-map
        :zoom="zoom"
        :center="center"
        :options="mapOptions"
        style="width: 100%; height: 100%"
        @update:center="centerUpdate"
        @update:zoom="zoomUpdate"
      >
        <l-tile-layer :url="url" :attribution="attribution" />
        <!-- <l-marker :lat-lng="withPopup" :icon="icon">
          <l-popup>
            <div style="width: 300px">
              <router-link to="/ops/operational"
                ><h4>AWB OCB Tanjung Lesung</h4></router-link
              >
              <b-row>
                <b-col md="12">
                  <b-card-text>
                    <b-row class="text-center">
                      <b-col
                        v-b-modal.operational-1
                        cols="4"
                        md="3"
                        class="mb-3"
                      >
                        <img
                          v-b-tooltip.top="'Operational'"
                          src="../../../../assets/images/flaticon/operational.png"
                          alt="Responsive Image"
                          style="cursor: pointer"
                        />
                        <small class="text-muted">Operational</small>
                      </b-col>

                      <b-modal
                        id="operational-1"
                        size="huge"
                        :no-close-on-backdrop="true"
                        :header-bg-variant="modal.headerBgVariant"
                        :header-text-variant="modal.headerTextVariant"
                        :body-bg-variant="modal.bodyBgVariant"
                        :body-text-variant="modal.bodyTextVariant"
                        hide-footer
                      >
                        <template v-slot:modal-header="{ close }">
                          <h5 class="text-white"
                            >AWB OCB Tanjung Lesung - Operational</h5
                          >

                          <b-button
                            size="md"
                            variant="outline-danger"
                            @click="close"
                          >
                            <i class="fa fa-times"></i> Close
                          </b-button>
                        </template>
                        <p>Test</p>
                      </b-modal>

                      <b-col
                        v-b-modal.certificate-1
                        cols="4"
                        md="3"
                        class="mb-3"
                      >
                        <img
                          v-b-tooltip.top="'Certificate'"
                          src="../../../../assets/images/flaticon/certificate.png"
                          alt="Responsive image"
                          style="cursor: pointer"
                        />
                        <small class="text-muted">Certificate</small>
                      </b-col>

                      <b-modal
                        id="certificate-1"
                        size="huge"
                        :no-close-on-backdrop="true"
                        :header-bg-variant="modal.headerBgVariant"
                        :header-text-variant="modal.headerTextVariant"
                        :body-bg-variant="modal.bodyBgVariant"
                        :body-text-variant="modal.bodyTextVariant"
                        hide-footer
                      >
                        <template v-slot:modal-header="{ close }">
                          <h5 class="text-white"
                            >AWB OCB Tanjung Lesung - Certificate</h5
                          >
                          <b-button
                            size="md"
                            variant="outline-danger"
                            @click="close"
                          >
                            <i class="fa fa-times"></i> Close
                          </b-button>
                        </template>
                        <Certificate></Certificate>
                      </b-modal>

                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="/ops/fleet-information">
                          <img
                            v-b-tooltip.top="'HSE'"
                            src="../../../../assets/images/flaticon/report.png"
                            alt="Responsive image"
                          />
                          <small class="text-muted">Information</small>
                        </router-link>
                      </b-col>
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="/maintenance-fleet">
                          <img
                            v-b-tooltip.top="'Maintenance'"
                            src="../../../../assets/images/flaticon/maintenance.png"
                            alt="Responsive image"
                          />
                          <small class="text-muted">Maintenance</small>
                        </router-link>
                      </b-col>
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="/ops/service-repair">
                          <img
                            v-b-tooltip.top="'Service & Repair'"
                            src="../../../../assets/images/flaticon/servicerepair.png"
                            alt="Responsive image"
                          />
                          <small class="text-muted">Service & Repair</small>
                        </router-link>
                      </b-col>
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="/ops/docking">
                          <img
                            v-b-tooltip.top="'Docking'"
                            src="../../../../assets/images/flaticon/docking.png"
                            alt="Responsive image"
                          />
                          <small class="text-muted">Docking</small>
                        </router-link>
                      </b-col>
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="">
                          <img
                            v-b-tooltip.top="'Crewing'"
                            src="../../../../assets/images/flaticon/crewing.png"
                            alt="Responsive image"
                          />
                          <small class="text-muted">Crewing</small>
                        </router-link>
                      </b-col>
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="">
                          <img
                            v-b-tooltip.top="'PR & Logistic'"
                            src="../../../../assets/images/flaticon/procurement.png"
                            alt="Responsive image"
                          />
                          <small class="text-muted">PR & Logistic</small>
                        </router-link>
                      </b-col>
                      <b-col md="12">
                        <router-link to="/ops/docking">
                          <b-button block variant="warning" class="mb-3"
                            ><i class="fa fa-ship"></i>Docking Intermediate
                            Survey</b-button
                          >
                        </router-link>
                      </b-col>
                    </b-row>
                  </b-card-text>
                </b-col>
              </b-row>
            </div>
          </l-popup>
          <l-tooltip :options="{ permanent: false, interactive: true }"
            >AWB OCB Tanjung Lesung</l-tooltip
          >
        </l-marker>
        <l-marker :lat-lng="withTooltip" :icon="icon">
          <l-popup>
            <div style="width: 300px">
              <router-link to="/ops/operational"
                ><h4>AWB Star Onyx</h4></router-link
              >
              <b-row>
                <b-col md="12">
                  <b-card-text>
                    <b-row class="text-center">
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="/ops/operational">
                          <img
                            v-b-tooltip.top="'Operational'"
                            src="../../../../assets/images/flaticon/operational.png"
                            alt="Responsive Image"
                          />
                          <small class="text-muted">Operational</small>
                        </router-link>
                      </b-col>
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="/ops/certificate">
                          <img
                            v-b-tooltip.top="'Certificate'"
                            src="../../../../assets/images/flaticon/certificate.png"
                            alt="Responsive image"
                          />
                          <small class="text-muted">Certificate</small>
                        </router-link>
                      </b-col>
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="/ops/fleet-information">
                          <img
                            v-b-tooltip.top="'HSE'"
                            src="../../../../assets/images/flaticon/report.png"
                            alt="Responsive image"
                          />
                          <small class="text-muted">Information</small>
                        </router-link>
                      </b-col>
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="/maintenance-fleet">
                          <img
                            v-b-tooltip.top="'Maintenance'"
                            src="../../../../assets/images/flaticon/maintenance.png"
                            alt="Responsive image"
                          />
                          <small class="text-muted">Maintenance</small>
                        </router-link>
                      </b-col>
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="/ops/service-repair">
                          <img
                            v-b-tooltip.top="'Service & Repair'"
                            src="../../../../assets/images/flaticon/servicerepair.png"
                            alt="Responsive image"
                          />
                          <small class="text-muted">Service & Repair</small>
                        </router-link>
                      </b-col>
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="/ops/docking">
                          <img
                            v-b-tooltip.top="'Docking'"
                            src="../../../../assets/images/flaticon/docking.png"
                            alt="Responsive image"
                          />
                          <small class="text-muted">Docking</small>
                        </router-link>
                      </b-col>
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="">
                          <img
                            v-b-tooltip.top="'Crewing'"
                            src="../../../../assets/images/flaticon/crewing.png"
                            alt="Responsive image"
                          />
                          <small class="text-muted">Crewing</small>
                        </router-link>
                      </b-col>
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="">
                          <img
                            v-b-tooltip.top="'PR & Logistic'"
                            src="../../../../assets/images/flaticon/procurement.png"
                            alt="Responsive image"
                          />
                          <small class="text-muted">PR & Logistic</small>
                        </router-link>
                      </b-col>
                    </b-row>
                  </b-card-text>
                </b-col>
              </b-row>
            </div>
          </l-popup>
          <l-tooltip :options="{ permanent: false, interactive: true }"
            >AWB Star Onyx</l-tooltip
          >
        </l-marker>
        <l-marker :lat-lng="dsvAtlasHawk" :icon="iconDSV">
          <l-popup>
            <div style="width: 300px">
              <router-link to="/ops/operational"
                ><h4>DSV Atlas Hawk</h4></router-link
              >
              <b-row>
                <b-col md="12">
                  <b-card-text>
                    <b-row class="text-center">
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="/ops/operational">
                          <img
                            v-b-tooltip.top="'Operational'"
                            src="../../../../assets/images/flaticon/operational.png"
                            alt="Responsive Image"
                          />
                          <small class="text-muted">Operational</small>
                        </router-link>
                      </b-col>
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="/ops/certificate">
                          <img
                            v-b-tooltip.top="'Certificate'"
                            src="../../../../assets/images/flaticon/certificate.png"
                            alt="Responsive image"
                          />
                          <small class="text-muted">Certificate</small>
                        </router-link>
                      </b-col>
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="/ops/fleet-information">
                          <img
                            v-b-tooltip.top="'HSE'"
                            src="../../../../assets/images/flaticon/report.png"
                            alt="Responsive image"
                          />
                          <small class="text-muted">Information</small>
                        </router-link>
                      </b-col>
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="/maintenance-fleet">
                          <img
                            v-b-tooltip.top="'Maintenance'"
                            src="../../../../assets/images/flaticon/maintenance.png"
                            alt="Responsive image"
                          />
                          <small class="text-muted">Maintenance</small>
                        </router-link>
                      </b-col>
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="/ops/service-repair">
                          <img
                            v-b-tooltip.top="'Service & Repair'"
                            src="../../../../assets/images/flaticon/servicerepair.png"
                            alt="Responsive image"
                          />
                          <small class="text-muted">Service & Repair</small>
                        </router-link>
                      </b-col>
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="/ops/docking">
                          <img
                            v-b-tooltip.top="'Docking'"
                            src="../../../../assets/images/flaticon/docking.png"
                            alt="Responsive image"
                          />
                          <small class="text-muted">Docking</small>
                        </router-link>
                      </b-col>
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="">
                          <img
                            v-b-tooltip.top="'Crewing'"
                            src="../../../../assets/images/flaticon/crewing.png"
                            alt="Responsive image"
                          />
                          <small class="text-muted">Crewing</small>
                        </router-link>
                      </b-col>
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="">
                          <img
                            v-b-tooltip.top="'PR & Logistic'"
                            src="../../../../assets/images/flaticon/procurement.png"
                            alt="Responsive image"
                          />
                          <small class="text-muted">PR & Logistic</small>
                        </router-link>
                      </b-col>
                    </b-row>
                  </b-card-text>
                </b-col>
              </b-row>
            </div>
          </l-popup>
          <l-tooltip :options="{ permanent: false, interactive: true }"
            >DSV Atlas Hawk</l-tooltip
          >
        </l-marker>
        <l-marker :lat-lng="ahtsTritonArjuna" :icon="iconAHTS">
          <l-popup>
            <div style="width: 300px">
              <router-link to="/ops/operational"
                ><h4>AHTS Triton Arjuna</h4></router-link
              >
              <b-row>
                <b-col md="12">
                  <b-card-text>
                    <b-row class="text-center">
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="/ops/operational">
                          <img
                            v-b-tooltip.top="'Operational'"
                            src="../../../../assets/images/flaticon/operational.png"
                            alt="Responsive Image"
                          />
                          <small class="text-muted">Operational</small>
                        </router-link>
                      </b-col>
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="/ops/certificate">
                          <img
                            v-b-tooltip.top="'Certificate'"
                            src="../../../../assets/images/flaticon/certificate.png"
                            alt="Responsive image"
                          />
                          <small class="text-muted">Certificate</small>
                        </router-link>
                      </b-col>
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="/ops/fleet-information">
                          <img
                            v-b-tooltip.top="'HSE'"
                            src="../../../../assets/images/flaticon/report.png"
                            alt="Responsive image"
                          />
                          <small class="text-muted">Information</small>
                        </router-link>
                      </b-col>
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="/maintenance-fleet">
                          <img
                            v-b-tooltip.top="'Maintenance'"
                            src="../../../../assets/images/flaticon/maintenance.png"
                            alt="Responsive image"
                          />
                          <small class="text-muted">Maintenance</small>
                        </router-link>
                      </b-col>
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="/ops/service-repair">
                          <img
                            v-b-tooltip.top="'Service & Repair'"
                            src="../../../../assets/images/flaticon/servicerepair.png"
                            alt="Responsive image"
                          />
                          <small class="text-muted">Service & Repair</small>
                        </router-link>
                      </b-col>
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="/ops/docking">
                          <img
                            v-b-tooltip.top="'Docking'"
                            src="../../../../assets/images/flaticon/docking.png"
                            alt="Responsive image"
                          />
                          <small class="text-muted">Docking</small>
                        </router-link>
                      </b-col>
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="">
                          <img
                            v-b-tooltip.top="'Crewing'"
                            src="../../../../assets/images/flaticon/crewing.png"
                            alt="Responsive image"
                          />
                          <small class="text-muted">Crewing</small>
                        </router-link>
                      </b-col>
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="">
                          <img
                            v-b-tooltip.top="'PR & Logistic'"
                            src="../../../../assets/images/flaticon/procurement.png"
                            alt="Responsive image"
                          />
                          <small class="text-muted">PR & Logistic</small>
                        </router-link>
                      </b-col>
                    </b-row>
                  </b-card-text>
                </b-col>
              </b-row>
            </div>
          </l-popup>
          <l-tooltip :options="{ permanent: false, interactive: true }"
            >AHTS Triton Arjuna</l-tooltip
          >
        </l-marker>
        <l-marker :lat-lng="ahtsTritonJawara" :icon="iconAHTS">
          <l-popup>
            <div style="width: 300px">
              <router-link to="/ops/operational"
                ><h4>AHTS Triton Jawara</h4></router-link
              >
              <b-row>
                <b-col md="12">
                  <b-card-text>
                    <b-row class="text-center">
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="/ops/operational">
                          <img
                            v-b-tooltip.top="'Operational'"
                            src="../../../../assets/images/flaticon/operational.png"
                            alt="Responsive Image"
                          />
                          <small class="text-muted">Operational</small>
                        </router-link>
                      </b-col>
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="/ops/certificate">
                          <img
                            v-b-tooltip.top="'Certificate'"
                            src="../../../../assets/images/flaticon/certificate.png"
                            alt="Responsive image"
                          />
                          <small class="text-muted">Certificate</small>
                        </router-link>
                      </b-col>
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="/ops/fleet-information">
                          <img
                            v-b-tooltip.top="'HSE'"
                            src="../../../../assets/images/flaticon/report.png"
                            alt="Responsive image"
                          />
                          <small class="text-muted">Information</small>
                        </router-link>
                      </b-col>
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="/maintenance-fleet">
                          <img
                            v-b-tooltip.top="'Maintenance'"
                            src="../../../../assets/images/flaticon/maintenance.png"
                            alt="Responsive image"
                          />
                          <small class="text-muted">Maintenance</small>
                        </router-link>
                      </b-col>
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="/ops/service-repair">
                          <img
                            v-b-tooltip.top="'Service & Repair'"
                            src="../../../../assets/images/flaticon/servicerepair.png"
                            alt="Responsive image"
                          />
                          <small class="text-muted">Service & Repair</small>
                        </router-link>
                      </b-col>
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="/ops/docking">
                          <img
                            v-b-tooltip.top="'Docking'"
                            src="../../../../assets/images/flaticon/docking.png"
                            alt="Responsive image"
                          />
                          <small class="text-muted">Docking</small>
                        </router-link>
                      </b-col>
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="">
                          <img
                            v-b-tooltip.top="'Crewing'"
                            src="../../../../assets/images/flaticon/crewing.png"
                            alt="Responsive image"
                          />
                          <small class="text-muted">Crewing</small>
                        </router-link>
                      </b-col>
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="">
                          <img
                            v-b-tooltip.top="'PR & Logistic'"
                            src="../../../../assets/images/flaticon/procurement.png"
                            alt="Responsive image"
                          />
                          <small class="text-muted">PR & Logistic</small>
                        </router-link>
                      </b-col>
                    </b-row>
                  </b-card-text>
                </b-col>
              </b-row>
            </div>
          </l-popup>
          <l-tooltip :options="{ permanent: false, interactive: true }"
            >AHTS Triton Jawara</l-tooltip
          >
        </l-marker>
        <l-marker :lat-lng="ahtsAtlasHarpectra" :icon="iconAHTS">
          <l-popup>
            <div style="width: 300px">
              <router-link to="/ops/operational"
                ><h4>AHTS Atlas Harpectra</h4></router-link
              >
              <b-row>
                <b-col md="12">
                  <b-card-text>
                    <b-row class="text-center">
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="/ops/operational">
                          <img
                            v-b-tooltip.top="'Operational'"
                            src="../../../../assets/images/flaticon/operational.png"
                            alt="Responsive Image"
                          />
                          <small class="text-muted">Operational</small>
                        </router-link>
                      </b-col>
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="/ops/certificate">
                          <img
                            v-b-tooltip.top="'Certificate'"
                            src="../../../../assets/images/flaticon/certificate.png"
                            alt="Responsive image"
                          />
                          <small class="text-muted">Certificate</small>
                        </router-link>
                      </b-col>
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="/ops/fleet-information">
                          <img
                            v-b-tooltip.top="'HSE'"
                            src="../../../../assets/images/flaticon/report.png"
                            alt="Responsive image"
                          />
                          <small class="text-muted">Information</small>
                        </router-link>
                      </b-col>
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="/maintenance-fleet">
                          <img
                            v-b-tooltip.top="'Maintenance'"
                            src="../../../../assets/images/flaticon/maintenance.png"
                            alt="Responsive image"
                          />
                          <small class="text-muted">Maintenance</small>
                        </router-link>
                      </b-col>
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="/ops/service-repair">
                          <img
                            v-b-tooltip.top="'Service & Repair'"
                            src="../../../../assets/images/flaticon/servicerepair.png"
                            alt="Responsive image"
                          />
                          <small class="text-muted">Service & Repair</small>
                        </router-link>
                      </b-col>
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="/ops/docking">
                          <img
                            v-b-tooltip.top="'Docking'"
                            src="../../../../assets/images/flaticon/docking.png"
                            alt="Responsive image"
                          />
                          <small class="text-muted">Docking</small>
                        </router-link>
                      </b-col>
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="">
                          <img
                            v-b-tooltip.top="'Crewing'"
                            src="../../../../assets/images/flaticon/crewing.png"
                            alt="Responsive image"
                          />
                          <small class="text-muted">Crewing</small>
                        </router-link>
                      </b-col>
                      <b-col cols="4" md="3" class="mb-3">
                        <router-link to="">
                          <img
                            v-b-tooltip.top="'PR & Logistic'"
                            src="../../../../assets/images/flaticon/procurement.png"
                            alt="Responsive image"
                          />
                          <small class="text-muted">PR & Logistic</small>
                        </router-link>
                      </b-col>
                    </b-row>
                  </b-card-text>
                </b-col>
              </b-row>
            </div>
          </l-popup>
          <l-tooltip :options="{ permanent: false, interactive: true }"
            >AHTS Atlas Harpectra</l-tooltip
          >
        </l-marker> -->
        
        <template v-for="(f, i) in fleetActivities">
          <l-marker :lat-lng="getLatLng(f.latitude, f.longitude)" :key="`fleet-${i}`">
            <l-icon
              :icon-size="iconSize"
              :icon-anchor="iconAnchor">
              <img style="width: 72px" :src="getIcon(f.vehicleType.icon)">
            </l-icon>

            <l-popup>
              <div style="width: 300px">
                <router-link to="/ops/operational"
                  ><h4>{{ f.name }}</h4></router-link
                >
                <b-row>
                  <b-col md="12">
                    <b-card-text>
                      <b-row class="text-center">
                        
                        <b-col cols="4" md="3" class="mb-3"
                          v-for="(m, im) in f.modules"
                          :key="`m-${im}`">
                          <router-link :to="{ path: m.url, query: {vehicleId: f.id } }">
                            <img v-if="
                              m.icon
                              && m.icon.url
                            " :src="m.icon.url" alt="Responsive image" v-b-tooltip.top="m.name">
                            <img v-else src="@assets/images/flaticon/operational.png" alt="Responsive image" v-b-tooltip.top="'Operational'">
                          </router-link>
                        </b-col>

                        <b-col md="12"
                          v-if="false">
                          <router-link to="/ops/docking">
                            <b-button block variant="warning" class="mb-3"
                              ><i class="fa fa-ship"></i>Docking Intermediate
                              Survey</b-button
                            >
                          </router-link>
                        </b-col>
                      </b-row>
                    </b-card-text>
                  </b-col>
                </b-row>
              </div>
            </l-popup>

            <l-tooltip :options="{ permanent: false, interactive: true }"
              >{{ f.name }}</l-tooltip
            >
          </l-marker>
        </template>

        <!--      <l-control
             :position="'bottomleft'"
             class="custom-control-watermark"
         >
           2021 &copy; TRITON GLOBAL MARITIM. All Rights Reserved. Developed with
           <i class="uil uil-heart text-danger font-size-12"></i> by
           <a href="https://taviahouse.com" target="_blank">Tavia House</a>
         </l-control>-->
      </l-map>
    </div>
    <!-- End of Open Street View -->
  </Layout>
</template>
